import _ from "underscore";
import { getDebugState, toggleDebugFlag } from "../../utils/debug";
import { MobileActions } from "../../store/mobile/actions";
import pageHTML from "./flags.tmpl";
import DebugPageView from "./debugPageView";

    export default class FlagsView extends DebugPageView {
        private readonly template = _.template(pageHTML);

        events () {
            return {
                "click .debugFlagToggleButton": "toggleFlag"
            };
        }

        render () {
            let debugState = getDebugState();
            let stateArray: any[] = [];

            if (debugState) {
                Object.keys(debugState).sort().forEach(key => {
                    if (debugState?.hasOwnProperty(key)) {
                        let state = debugState[key];

                        stateArray.push({ key, state });
                    }
                });
            }

            this.el.innerHTML = this.template({
                states: stateArray
            });

            this.app.store.dispatch(MobileActions.setPageState({
                title: "Debug Flags",
                pageLevel: 2
            }));

            return this;
        }

        toggleFlag (e) {
            let target = <HTMLElement>e.target;
            let flag = target.getAttribute("data-key");

            if (flag) {
                try {
                    toggleDebugFlag(flag);
                } catch (err) {
                    alert(err);
                }

                this.render();
            }
        }
    }